import { Box, Text, RadioGroup, Radio } from "@chakra-ui/react";
import { FilterByForm } from "../IssbDataInput/components/tools/FilterByComponent";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { applyFiltersOverList } from "../IssbDataInput/DataInputPanel";
import { useSelector } from "react-redux";
import SearchString from "search-string";

/**
 *
 * @param {IssbQuestion[]} fullQuestionList Normally not set - and we use the current round's questions
 * @param {string?} questionFilter Takes precedence over the url param `q`
 * @param {(questionFilter: string) => void} setQuestionFilter If provided, call this instead of modifying the url
 * @returns
 */
export default function AIReviewQuestionsPanel({
  questionIds,
  setQuestionIds,
  fullQuestionList,
  questionFilter,
  setQuestionFilter,
  helpText = "Select the requirements you want ESG360 AI to create draft answers for.",
  hideNumbers, // for when we havent got the full list of questions to show the right numbers
}) {
  // filterBy - copy pasta from DataInputPanel
  const [searchParams, setSearchParams] = useSearchParams();
  const filterBy = questionFilter || searchParams.get("q") || "";
  const setFilterBy = (value) => {
    if (setQuestionFilter) {
      setQuestionFilter(value);
      return;
    }
    const newParams = new URLSearchParams(searchParams);
    newParams.set("q", value);
    setSearchParams(newParams);
  };
  // radio group - default to all if no filter
  const [all, setAll] = useState(!filterBy);
  console.log("all", all, "filterBy", filterBy, "!filterBy", !filterBy);
  const roundSelector = useSelector((state) => state.issbRound);
  if (!fullQuestionList) fullQuestionList = roundSelector?.questions;

  const search = SearchString.parse(filterBy);
  const conditions = search.getConditionArray();

  const filteredQuestionList = applyFiltersOverList(fullQuestionList, filterBy);

  // let the parent know when the filter changes
  useEffect(() => {
    let qlist = fullQuestionList;
    if (!all) {
      qlist = applyFiltersOverList(fullQuestionList, filterBy);
    }
    setQuestionIds(qlist.map((q) => q.id));
  }, [all, filterBy, fullQuestionList, setQuestionIds]);

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      {helpText && <Text>{helpText}</Text>}
      <RadioGroup
        colorScheme="limeShade"
        value={all ? "all" : "selected"}
        display="flex"
        flexDirection="column"
        gap={4}
      >
        <Box border="solid 1px" p={4} borderRadius={6} borderColor="gray.300" bg={all ? "limeShade.50" : "transparent"}>
          <Radio value="all" onChange={(e) => setAll(true)}>
            <Text fontWeight="bold" fontSize="body.m">
              Generate for all requirements in this round{" "}
              {!hideNumbers && fullQuestionList && "(" + fullQuestionList.length + ")"}
            </Text>
          </Radio>
        </Box>
        <Box
          border="solid 1px"
          p={4}
          borderRadius={6}
          borderColor="gray.300"
          bg={!all ? "limeShade.50" : "transparent"}
        >
          <Radio value="selected" onChange={(e) => setAll(false)}>
            <Text fontWeight="bold" fontSize="body.m">
              Generate for selected requirements {!!filterBy && !hideNumbers ? `(${filteredQuestionList?.length})` : ""}
            </Text>
          </Radio>
        </Box>
      </RadioGroup>

      {/*{filterBy}*/}

      <Box opacity={all ? 0.5 : 1}>
        {!all && (
          <FilterByForm
            filterBy={filterBy}
            setFilterBy={setFilterBy}
            fullList={fullQuestionList}
            conditions={conditions}
          />
        )}
      </Box>
    </Box>
  );
}
